import { css, SerializedStyles } from '@emotion/react';
import { Theme } from '@shipengine/giger-theme';

export const getShipmentDetailsContentStyles = (theme: Theme): SerializedStyles =>
    css({
        display: 'grid',
        gridGap: `0 ${theme.spacing(4)}px`,
        gridTemplateAreas: `
                "label"
                "customs"
                "printerless"
                "carrierWarnings"
                "tracking1"
                "tracking2"
                "origin"
                "pudo"
                "sender"
                "destination"
                "recipient"
                "warning2"
                "order"
                "warning1"
                "price"

            `,

        [theme.mediaQuery('tablet')]: {
            gridTemplateColumns: '50% 50%',
            marginRight: theme.spacing(4),
            gridTemplateAreas: `
                "customs customs"
                "printerless printerless"
                "carrierWarnings carrierWarnings"
                "tracking1 tracking2"
                "origin destination"
                "pudo pudo"
                "sender recipient"
                "warning1 warning2"
                "order price"
            `,
        },
    });

export const getGridElementStyles =
    (area: string) =>
    (theme: Theme): SerializedStyles =>
        css({
            gridArea: area,
            marginBottom: theme.spacing(4),
        });

export const getShipmentDetailsEmailAndPackagingStyles = (): SerializedStyles =>
    css({
        article: {
            height: '100%',
        },
    });

export const getDropoffMapStyles = (theme: Theme): SerializedStyles =>
    css({
        border: `1px solid ${theme.palette.gray[200]}`,
        padding: theme.spacing(2),
        borderRadius: theme.borderRadius.M,
    });

export const getDropoffMapDividerStyles = (theme: Theme): SerializedStyles =>
    css({
        margin: `${theme.spacing(2)}px 0 ${theme.spacing()}px`,
    });

export const getShowDropoffMapBtnStyles = (theme: Theme): SerializedStyles =>
    css({
        marginTop: theme.spacing(2),
    });

export const getShipmentDetailsNotificationStyles = (theme: Theme): SerializedStyles =>
    css({
        marginBottom: theme.spacing(3),
    });
